import map from "lodash/map"
import get from "lodash/get"
import { Component } from "react"
import PropTypes from "prop-types"
import TextField from "component-lib/Base/components/TextField/TextField"

export default class TextInputForm extends Component {
  constructor(props) {
    super(props)

    const textInputs = map(props.textInputs, (textInputProps) => ({
      value: textInputProps.value,
    }))

    this.state = {
      textInputs,
    }
  }

  handleFormSubmit = (e) => {
    e.preventDefault()
  }

  renderTextInputs() {
    const { hideNoError, language, textInputs } = this.props

    const emptyHelperText = hideNoError ? "" : " "

    return map(textInputs, (textInputProps, index) => {
      const keyValue = textInputProps.label.replace(/\s/g, ``)
      return (
        <TextField
          variant="outlined"
          fullWidth
          language={language}
          key={`${index}TextInput${keyValue}`}
          {...textInputProps}
          onChange={(e) => {
            const {
              target: { value },
            } = e
            if (textInputProps.onChange !== undefined) {
              textInputProps.onChange(e)
            }
            this.setState((prevState) => ({
              textInputs: {
                ...prevState.textInputs,
                [index]: {
                  value,
                },
              },
            }))
          }}
          value={get(this.state, `textInputs[${index}].value`, ``)}
          helperText={
            textInputProps.helperText
              ? textInputProps.helperText
              : emptyHelperText
          }
        />
      )
    })
  }

  renderFooter() {
    const { footerChildren } = this.props

    return footerChildren
  }

  render() {
    const { className, footerChildren, hideForm } = this.props

    return (
      <form
        className={`TextInputForm ${className}`}
        onSubmit={this.handleFormSubmit}
        data-testid="TextInputForm"
      >
        {!hideForm && (
          <div className="TextInputForm__inputs">{this.renderTextInputs()}</div>
        )}

        {footerChildren !== null ? this.renderFooter() : null}
      </form>
    )
  }
}

TextInputForm.propTypes = {
  textInputs: PropTypes.array.isRequired,
  language: PropTypes.string,
  className: PropTypes.string,
  footerChildren: PropTypes.node,
  hideNoError: PropTypes.bool,
  hideForm: PropTypes.bool,
}

TextInputForm.defaultProps = {
  language: ``,
  className: ``,
  footerChildren: null,
  hideNoError: false,
  hideForm: false,
}
